module.exports = require('./cjs/nivo-axes');